import { Loyalty, Edit, Iso } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { PaginationModel } from "utils/PaginationType";
import { Customer } from "./CustomerType";
import { CustomerRank } from "utils/constant";
import { SearchCustomerParams } from "./CustomerManagement";

export const CustomerTableColumns = (
  fetchCustomers: (page: number, pageSize: number, searchParams: SearchCustomerParams) => Promise<any>,
  paginationModel: PaginationModel,
  handleEdit: (customer: Customer) => void,
  handleAdjustmentPoint: (customer: any) => void,
  handleSendVoucher: (customer: any) => void
) => {
  return [
    { field: 'id', headerName: 'ID', width: 20, flex: 1 },
    { field: 'name', headerName: 'Tên', width: 100, flex: 1 },
    { field: 'phone', headerName: 'Số điện thoại', width: 100, flex: 1 },
    { field: 'externalId', headerName: 'ZALO ID', width: 100, flex: 1 },
    { field: 'currentPoint', headerName: 'Điểm hiện có', width: 100, flex: 1 },
    { field: 'accumulatedPoint', headerName: 'Điểm tích lũy', width: 100, flex: 1 },
    { field: 'rank', headerName: 'Hạng', width: 100, flex: 1, renderCell: (params: any) => {
      return CustomerRank[params.row.rank as keyof typeof CustomerRank]
    }},
    { field: 'actions', headerName: 'Hành động', width: 100, flex: 1, renderCell: (params: any) => {
      return <>
      <IconButton color="primary" title="Chỉnh sửa thông tin khách hàng" onClick={() => handleEdit(params.row)}>
        <Edit />
      </IconButton>
      <IconButton color="warning" title="Chỉnh sửa điểm tích lũy" onClick={() => handleAdjustmentPoint(params.row)}>
        <Iso />
      </IconButton>
      <IconButton color="success" title="Gửi voucher" onClick={() => handleSendVoucher(params.row)}>
        <Loyalty />
      </IconButton>
      </>
    }},
  ];
};